import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'
import { useToasts } from './useToasts'

export function useDeviceControl() {
  const qc = useQueryClient()
  const { push } = useToasts()
  return useMutation({
    mutationFn: ({ id, on, channel = 0 }: { id: string; on: boolean; channel?: number }) =>
      api.controlDevice(id, { on, channel }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['devices'] }),
    onError: (e) => push('error', (e as Error)?.message || 'Errore comando'),
  })
}
